"use client";

import React from "react";

import { Skeleton } from "@perceptron/ui/components/skeleton";

export interface EditorLoadingSkeletonProps {
  lines?: number;
}

/**
 * Dedicated loading state component for the editor.
 *
 * @param props Loading skeleton configuration
 * @returns Rendered loading skeleton
 */
export function EditorLoadingSkeleton({ lines = 4 }: EditorLoadingSkeletonProps) {
  return (
    <div className="absolute inset-0 space-y-3 p-4">
      {Array.from({ length: lines }).map((_, index) => (
        <Skeleton className="h-4 w-20" key={index} />
      ))}
    </div>
  );
}
